<template>
  <div class="createBooking">
    <v-row justify="center" no-gutters>
      <v-col cols="11" md="8" lg="6" class="my-2 px-1">      
        <!--div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            range
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRangeText"
                :label="createBookingLabel('date_range_label')"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              :locale="localeTranslate()"
              v-model="form.dates"
              color="green lighten-2"
              range
            >
              <v-spacer></v-spacer>
              <v-btn text color="green " @click="menu = false">
                {{ $t("manage.by_school.booking.create_booking.btn_datepicker_close") }}
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div-->
        <v-row>
          <v-col cols="12">
            <v-select
              :items="api.schools"
              item-text="school_id"
              item-value="school_id"
              v-model="form.school_id"
              :label="createBookingLabel('school_label')"
              :disabled="current.user_level!='ADMIN'"
              readonly
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-select
              :items="api.experiments"
              item-text="experiment_set"
              item-value="experiment_set"
              v-model="form.selected_experiment"
              :label="createBookingLabel('experiment_set_label')"
              no-data-text="No Experiment Available"
              @change="changeExperimentSet(form.selected_experiment);"
            ></v-select>
          </v-col>
        </v-row>
        <hr>        
        <v-row>
          <v-col col="12">
            <small style="color: #868686; font-size: 12px;">
              {{ $t("manage.by_school.booking.create_booking.date_range_label") }}
            </small>
            <br>
            <date-picker :placeholder="createBookingLabel('date_range_label')" v-model="form.dates2" range></date-picker>
          </v-col>
        </v-row>
        <hr>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.start_from"
              :label="createBookingLabel('open_hour_label')"
              type="time"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.end_at"
              :label="createBookingLabel('close_hour_label')"
              type="time"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="py-0">
            <small class="red--text text--accent-2">{{ $t("manage.by_school.booking.create_booking.daily_close_hour_note") }}</small>
          </v-col>
        </v-row>
        <hr>
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.duration"
              :label="createBookingLabel('duration_label')"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="form.prepare"
              :label="createBookingLabel('prepare_time_label')"
            ></v-text-field>
          </v-col>
        </v-row>
        <hr>
        <v-row>
          <v-col>
            <v-row align="center">
              <v-checkbox
                v-model="assignCheckbox"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
              <v-select
                multiple
                chips
                :items="api.groups"
                item-text="user_group"
                item-value="user_group"
                v-model="form.groups"
                :label="createBookingLabel('assign_label')"
                :disabled="!assignCheckbox"
              ></v-select>
            </v-row>
          </v-col>
        </v-row>
        <!--v-btn class="ma-4" @click="createBookSlots;"-->
        <v-btn class="ma-4" @click="openCreateBookSlotsDialog();">
          {{ $t("manage.by_school.booking.create_booking.btn_create_book_slot") }}
        </v-btn>
        <hr />
      </v-col>
    </v-row>
    <v-dialog v-model="createBookSlotsDialog" max-width="600px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="createBookSlotsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("manage.by_school.booking.create_booking.create.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11" class="my-2 px-1">
            <table>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.school") }}</th>
                <td>{{ form.school_id }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.experiment_set") }}</th>
                <td>{{ form.experiment }} - {{ form.equipment_id }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.date_range") }}</th>
                <td>{{ form.dates2[0] | moment("YYYY-MM-DD") }} ~ {{ form.dates2[1] | moment("YYYY-MM-DD") }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.daily_hour") }}</th>
                <td>{{ form.start_from }} ~ {{ form.end_at }}</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.session") }}</th>
                <td>{{ form.duration }} ({{ $t("manage.by_school.booking.create_booking.create.minute") }}) + {{ form.prepare }} ({{ $t("manage.by_school.booking.create_booking.create.minute") }})</td>
              </tr>
              <tr>
                <th class="px-3">{{ $t("manage.by_school.booking.create_booking.create.user_group") }}</th>
                <td v-if="assignCheckbox">{{ form.groups.toString() }}</td>
                <td v-else></td>
              </tr>
            </table>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="" text @click="createBookSlotsDialog = false">
                {{ $t("manage.by_school.booking.create_booking.create.btn_discard") }}
              </v-btn>
              <v-btn color="primary" text @click="createBookSlots">
                {{ $t("manage.by_school.booking.create_booking.create.btn_create") }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment, { duration } from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
// import 'vue2-datepicker/locale/zh-cn';
import { api_management } from "@/services/iot/api_management";
import { api_booking } from "@/services/iot/api_booking";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
export default {
  components: { 
    DatePicker 
  },
  name: "CreateBookSlot",
  data: function () {
    return {
      createBookSlotsDialog: false,
      assignCheckbox: false,
      menu: false,
      dialog: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api: {
        groups: [],
        schools: [],
        experiment_sets: [],
        experiments: [
          {
            field: "BIOLOGY",
            experiment: "BACTERIA_GROWTH",
            experiment_name: "Bacteria Growth",
            status: "ACTIVE",
            create_at: "2022-09-06 15:55:17",
          },
        ],
      },
      form: {
        selected_experiment: "",
        start_from: "09:00",
        end_at: "18:00",
        duration: "55",
        prepare: "5",
        school_id: "",
        dates: [],
        dates2: [],
        groups: [],
        experiment: "",
        equipment_id: "",
      },
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.api.schools = [self.current.school_id];
    self.form.school_id = self.current.school_id;
    apiManagement.getSchoolExperiment(self.current.school_id).then((response) => {
      self.api.experiments = response.experiments;
    });    
    self.getSchoolUserGroups();
  },  
  computed: {
    dateRangeText() {
      return this.form.dates.join(" ~ ");
    },
    calculated_no_of_slots() {
      var self = this;
      return 1440 / (parseInt(self.form.duration) + parseInt(self.form.rest));
    },
  },
  methods: {
    isValid: function(){
      var self = this;
      
      let date3 = moment(self.form.dates2[0]);
      let date4 = moment(self.form.dates2[1]);

      let time1 = moment(self.form.start_from, "HH:mm", true);
      let time2 = moment(self.form.end_at, "HH:mm", true);
      let timeDiff = time2.diff(time1);

      

      if(self.form.experiment==""){
        alert("Fail! Missing experiment");
        return false;
      }
      if(self.form.equipment_id==""){
        alert("Fail! Missing experiment");
        return false;
      }
      if(self.form.dates2[0]==null){
        alert("Fail! Missing start date");
        return false;
      }
      if(self.form.dates2[1]==null){
        alert("Fail! Missing end date");
        return false;
      }
      if( self.form.start_from.trim()=="" ){
        alert("Fail! Missing open hour");
        return false;
      }
      if( self.form.end_at.trim()=="" ){
        alert("Fail! Missing close hour");
        return false;
      }
      if( moment(self.form.start_from, "HH:mm", true).isValid() == false){
        alert("Fail! Invalid time format of open hour");
        return false;
      }
      if( moment(self.form.end_at, "HH:mm", true).isValid() == false){
        alert("Fail! Invalid time format of close hour");
        return false;
      }
      if( self.form.duration=="".trim() || isNaN(self.form.duration.trim()) ){
        alert("Fail! Missing or wrong format to duration");
        return false;
      }
      if( self.form.prepare=="".trim() || isNaN(self.form.prepare.trim()) ){
        alert("Fail! Missing or wrong format to preparation");
        return false;
      }

      if( date4.diff(date3) < 0 ){
        alert("Invalid Date and Time! Start time must be sooner than End time!");
        return false;
      }
      if( time2.diff(time1) < 0 ){
        alert("Invalid Time! Open hour must be sooner than Close time!");
        return false;
      }
      if( (timeDiff/1000/60) < (parseInt(self.form.duration)+parseInt(self.form.prepare))){
        alert("Fail! Please make sure at least 1 slot can be created");
        return false;
      }

      return true;
    },
    openCreateBookSlotsDialog(){
      var self = this;
      if(self.isValid()){
        self.createBookSlotsDialog = true;
      }
    },
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.form.experiment = split[0];
      self.form.equipment_id = split[1];
    },
    createBookSlots: function () {
      var self = this;
      let groups = [];
      if(self.assignCheckbox){
        groups = self.form.groups;
      }
      if (self.isValid()) {

        apiManagement.createBookSlots(
          self.form.school_id,
          self.form.experiment,
          self.form.equipment_id,
          moment(self.form.dates2[0]).format("YYYY-MM-DD"),
          moment(self.form.dates2[1]).format("YYYY-MM-DD"),
          self.form.start_from,
          self.form.end_at,
          self.form.duration,
          self.form.prepare,
          groups,
          self.current.username
        )
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.createBookSlotsDialog = false;
//            alert("Assigned " + response.count + " slots successfully");
          } else {
            alert(response.message);
          }
        });        
      }
    },
    getSchoolUserGroups(){
      var self = this;
      apiManagement.getSchoolUserGroups(self.current.school_id)
      .then((response) => {
          self.api.groups = response.groups;
      });
    },
    createBookingLabel(label){
      var self = this;
      if(label=='school_label') return self.$t("manage.by_school.booking.school");
      else if(label=='experiment_set_label') return self.$t("manage.by_school.booking.create_booking.experiment_set");
      else if(label=='date_range_label') return self.$t("manage.by_school.booking.create_booking.date_range");
      else if(label=='open_hour_label') return self.$t("manage.by_school.booking.create_booking.daily_open_hour");
      else if(label=='close_hour_label') return self.$t("manage.by_school.booking.create_booking.daily_close_hour");
      else if(label=='duration_label') return self.$t("manage.by_school.booking.create_booking.duration");
      else if(label=='prepare_time_label') return self.$t("manage.by_school.booking.create_booking.prepare_time");
      else if(label=='assign_label') return self.$t("manage.by_school.booking.create_booking.assign_to");
    },
    closeDialog() {
      this.$emit("update-parent-dialog", false);
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>